import { Company } from "./GuestSubsCompany";

export class User {

  id: number;

  username: string;
  password: string;

  editPermissions: number;
  visibilityPermissions: number;

  companiesList: Company[];

  parkID: number;

  constructor() {
    this.id = 0;
    this.username = '';
    this.password = '';

    this.editPermissions = 0;
    this.visibilityPermissions = 0;

    this.companiesList = [];
    this.parkID;
  }
}
